import { DRAWER_TYPES } from '@/constants/drawer';
import { ROLES } from '@/constants/roles';
import { isProductionMode, isVcht } from '@/constants/global';
import { PERMISSIONS } from '@/constants/permissions';
import { uiEventPlan } from '@/modules/EventsPlan/routes';

export const nominations = {
  path: '/nominations',
  name: 'nominations',
  component: () => import('./views/EventNominations.vue'),
  meta: {
    title: 'Номинации',
    icon: '$istar-outline',
    accessList: [ROLES.organization],
  },
};

export const eventsStock = {
  path: '/events/market',
  name: 'events-market',
  component: () => import('@/modules/UIDesign/Events/views/event-market.vue'),
  meta: {
    title: 'Биржа мероприятий',
    accessList: [ROLES.organization, ROLES.expert],
    icon: 'mdi-bank-outline',
    instruction: {
      id: 115,
      name: 'Создание заявки',
    },
    layout: 'ui-design',
    back: true,
    children: [
      {
        text: 'Поиск мероприятий',
        to: '/events/market',
        icon: 'mdi-store',
        visibleFor: [ROLES.organization],
      },
      {
        text: 'Мои заявки',
        to: '/events/market/my-requests',
        icon: 'mdi-folder-account',
        visibleFor: [ROLES.organization],
      },
      {
        text: 'Заявки организаторов',
        icon: 'mdi-account-tie',
        to: '/organization/events/manage',
        visibleFor: [ROLES.organization],
      },
    ],
  },
};

export const eventsRequestedStock = {
  path: '/events/market/my-requests',
  name: 'events-market-requests',
  component: () => import('@/modules/UIDesign/Events/views/event-market-requests.vue'),
  meta: {
    title: 'Мои заявки',
    accessList: [ROLES.organization, ROLES.expert],
    layout: 'ui-design',
    back: true,
  },
};

export const eventAssociations = {
  path: '/organization-event-associations',
  name: 'organization-event-associations',
  component: () => import('./views/event-associations/event-associations.vue'),
  meta: {
    title: 'Ассоциации',
    icon: '$ifolder-favorite-outline',
    accessList: [ROLES.organization],
  },
};
export const eventAssociation = {
  path: '/organization-event-association/:id',
  name: 'organization-event-association',
  component: () => import('./views/event-associations/event-association.vue'),
  meta: {
    title: 'Ассоциация',
  },
};

export const eventsOrganizationManagementLink = {
  name: 'organization-events-my',
  meta: {
    title: 'Мои мероприятия',
    accessList: [ROLES.organization],
  },
};

// export const eventsOrganizationManagement = {
//   path: '/organization-events',
//   name: 'organization-events',
//   component: () => import('./views/management/organization/index.vue'),
//   redirect: () => ({
//     name: 'ui-events-organizer',
//   }),
//   children: [
//     {
//       name: 'organization-events-my',
//       path: 'my',
//       component: () => import('./views/management/organization/children/my.vue'),
//       meta: {
//         title: 'Мои мероприятия',
//         layout: 'ui-design',
//         accessList: [ROLES.organization],
//       },
//       redirect: () => ({
//         name: 'ui-events-organizer',
//       }),
//     },
//     {
//       name: 'organization-events-assigned',
//       path: 'assigned',
//       component: () => import('./views/management/organization/children/assigned.vue'),
//       meta: {
//         title: 'Назначенные мероприятия',
//         layout: 'ui-design',
//         accessList: [ROLES.organization],
//       },
//       redirect: () => ({
//         name: 'ui-events-organizer',
//       }),
//     },
//   ],
//   meta: {
//     title: 'Мероприятия',
//     layout: 'ui-design',
//     accessList: [ROLES.organization],
//   },
// };

export const uiEventsStockDashboard = {
  path: '/events/market-dashboard',
  name: 'events-market-dashboard',
  component: () => import('./views/MarketEvents/views/Dashboard.vue'),
  meta: {
    title: 'Совместные мероприятия',
    accessList: [ROLES.organization, ROLES.expert],
    layout: 'ui-design',
  },
};

export const events = {
  meta: {
    title: 'Мероприятия',
    icon: '$icalendar',
    accessList: [ROLES.organization, ROLES.certificate, ROLES.member, ROLES.expert, ROLES.trainer, ROLES.event_manager],
    instruction: {
      id: { [ROLES.member]: 29, [ROLES.certificate]: 29 },
      name: 'Мероприятия',
    },
    children: [
      {
        text: 'Управление мероприятиями',
        to: { name: 'ui-events-organizer' },
        icon: 'mdi-calendar-edit',
        visibleFor: [ROLES.organization, ROLES.event_manager],
      },
      // {
      //   text: 'Группы мероприятий',
      //   to: '/event/categories',
      //   icon: 'mdi-calendar-multiple',
      //   visibleFor: [ROLES.organization],
      // },
      {
        text: 'Создать мероприятие',
        to: isProductionMode ? '/event-create' : '/event/template-create', // ШАБЛОНЫ (ТИПЫ) МЕРОПРИЯТИЙ: закрыты на проде
        icon: `mdi-calendar-plus`,
        vchtWhitelisted: isVcht,
        visibleFor: [ROLES.organization, ROLES.event_manager],
        accessFor: [PERMISSIONS.event_create],
      },
      // {
      //   text: 'Черновики',
      //   to: '/event/drafts',
      //   icon: 'mdi-calendar-text-outline',
      //   visibleFor: [ROLES.organization],
      // },
      {
        text: 'Мои мероприятия',
        to: '/certificate-events',
        icon: 'mdi-calendar-account-outline',
        visibleFor: [ROLES.member, ROLES.certificate],
      },
      // 11.12.2024 (9:44 MSK): Вадим сказал, функционал не выпиливаем,
      // это система заявочных этапов, пока просто скрываем
      // {
      //   text: 'Заявочные этапы',
      //   to: '/qualifications',
      //   icon: 'mdi-card-bulleted-settings-outline',
      //   visibleFor: [ROLES.member, ROLES.certificate],
      // },
      {
        text: 'Задания',
        to: '/polls/event',
        icon: 'mdi-format-list-checks',
        visibleFor: [ROLES.member, ROLES.certificate],
      },
      {
        text: 'Модерация мероприятий',
        icon: 'mdi-text-box-check-outline',
        to: '/events/moderation',
        visibleFor: [ROLES.operator, ROLES.moderator],
      },
      // {
      //   text: 'Коэффициенты мероприятий',
      //   to: '/events/significance-coefficient',
      //   icon: 'mdi-chart-pie',
      //   visibleFor: [ROLES.operator],
      // },
      {
        text: 'Готовность муниципалитетов',
        to: '/operator-appoint',
        icon: 'mdi-pencil-ruler',
        visibleFor: [ROLES.operator],
      },
      {
        text: 'Оценка работ',
        to: '/grading-assignments',
        icon: 'mdi-calendar-account-outline',
        visibleFor: [ROLES.expert],
      },
      // ТУТ ПОТОМ БУДЕТ СТАТИСТИКА ПО РАБОТАМ ДЛЯ ЭКСПЕРТА
      // {
      //   text: 'Результаты мероприятий',
      //   to: '/events/results',
      //   icon: 'mdi-trophy-award',
      //   visibleFor: [ROLES.expert],
      // },
    ],
  },
};

export default [
  events,
  eventsStock,
  uiEventPlan,
  eventAssociation,
  eventAssociations,
  uiEventsStockDashboard,
  eventsRequestedStock,
  // eventsOrganizationManagement,
  // eventsCertificateManagement,
  // eventsExpertManagement,
  nominations,

  {
    path: '/event/create',
    name: 'event-create',
    component: () => import('@/modules/Events/views/event-create-redesign.vue'),
    meta: {
      title: 'Создание мероприятия',
      accessList: [ROLES.operator, ROLES.event_manager, ROLES.admin],
      permissionsList: [PERMISSIONS.event_create],
      instruction: { id: 1, name: 'Создание мероприятия' },
      subdrawer: DRAWER_TYPES.portal,
    },
  },
  {
    path: '/event/template-create',
    name: 'event-create-by-template',
    component: () => import('@/modules/Events/views/event-create-by-template.vue'),
    meta: {
      title: 'Создание мероприятия',
      accessList: [ROLES.organization, ROLES.operator, ROLES.event_manager],
      permissionsList: [PERMISSIONS.event_create],
    },
  },
  // {
  //   path: '/event/view/:id',
  //   name: 'event-view',
  //   component: () => import('./views/Event/index.vue'),
  //   meta: {
  //     title: 'Просмотр Мероприятий',
  //     subdrawer: DRAWER_TYPES.portal,
  //   },
  // },
  // { // NOTE: Можно удалять компонент, мы его не используем, но пока оставлю тут
  //   path: '/event/:id/edit',
  //   name: 'event-edit',
  //   component: () => import('./views/EditEvent/index.vue'),
  //   meta: {
  //     title: 'Редактирование мероприятия',
  //     accessList: [ROLES.organization, ROLES.operator],
  //     subdrawer: DRAWER_TYPES.portal,
  //   },
  //   props: true,
  // },
  // {
  //   path: '/events/significance-coefficient',
  //   name: 'events-significance-coefficient',
  //   component: () => import('./views/SignificanceCoefficient/index.vue'),
  //   meta: {
  //     accessList: [ROLES.operator],
  //     instruction: {
  //       id: 44,
  //       name: 'Коэффициенты мероприятий',
  //     },
  //   },
  // },
  {
    path: '/event/drafts',
    name: 'event-drafts',
    component: () => import('./views/Drafts/index.vue'),
    meta: {
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/events/market-applications',
    name: ' events/market-applications',
    component: () => import('./views/MarketEventsApplications/index.vue'),
    meta: {
      accessList: [ROLES.organization],
      layout: 'ui-design',
    },
  },
  {
    path: '/events/market-applications/:id',
    name: ' events/market-applications-id',
    component: () => import('./views/MarketEventApplications/index.vue'),
    meta: {
      accessList: [ROLES.organization],
      layout: 'ui-design',
    },
  },
  {
    path: '/operator-appoint',
    name: 'operator-appoint',
    component: () => import('./views/OperatorAppointEvents/index.vue'),
    meta: {
      accessList: [ROLES.operator],
      instruction: {
        id: 15,
        name: 'Готовность муниципалитетов',
      },
    },
  },
  {
    path: '/operator-appoint/:id',
    name: 'operator-appoint-id',
    component: () => import('./views/OperatorAppoint/index.vue'),
    meta: {
      accessList: [ROLES.operator],
    },
  },
  {
    path: '/department-events',
    name: 'department-events',
    component: () => import('./views/DepartamentEvents/index.vue'),
    meta: {
      accessList: [ROLES.department],
    },
  },
  // {
  //   path: '/event/register/:id',
  //   name: 'event-register',
  //   component: () => import('./views/event-register.vue'),
  //   meta: {
  //     title: 'Запись на мероприятие',
  //   },
  // },
  {
    // Remove later !!!!!
    path: '/event/import-members/:id',
    name: 'import-members',
    component: () => import('./views/import-members.vue'),
    meta: {
      title: 'Импорт участников',
    },
  },
  {
    path: '/event/:id/program',
    name: 'event-program-list',
    component: () => import('./views/event-stages-activities-list.vue'),
    meta: {
      title: 'Активности мероприятия',
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/event/:id/program/create',
    name: 'event-program-create',
    component: () => import('./views/event-stages-activities.vue'),
    meta: {
      title: 'Создание активности',
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/event/:id/program/edit/:idStage/:idActivity',
    name: 'event-program-edit',
    component: () => import('./views/event-stages-activities.vue'),
    meta: {
      title: 'Редактирование активности',
      accessList: [ROLES.organization],
    },
  },
  // {
  //   path: '/events/results',
  //   name: 'event-reports-results',
  //   component: () => import('./views/management/expert.vue'),
  //   meta: {
  //     isClosedEvent: true,
  //     accessList: [ROLES.expert],
  //   },
  // },
  // {
  //   path: '/events',
  //   name: 'event-reports',
  //   component: () => import('./views/management/expert.vue'),
  //   meta: {
  //     accessList: [ROLES.expert, ROLES.organization],
  //   },
  // },
  {
    path: '/event/:eventId/news/:id',
    name: 'news-view',
    component: () => import('./views/news-view.vue'),
    meta: {
      title: 'Просмотр новости',
    },
  },
];
